import axios, { AxiosError } from 'axios';
import {
  openCannotChangeCurrentResourceNotify_405,
  openClientErrorNotify_400,
  openServerErrorNotify_500,
} from '@shared/hooks/use-error-handler.ts';
import { AppStore } from '@src/app/providers/store.tsx';

let store: AppStore | null = null;

// Call this once from setup to inject store
export const injectStore = (_store: AppStore) => {
  store = _store;
};

export const instanceCore = axios.create({
  baseURL: '/api/v1/',
  withCredentials: true,
});

instanceCore.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');

  if (token) {
    // Ensure headers object exists
    config.headers = config.headers ?? {};
    config.headers['Authorization'] = `Token ${token}`;
  }

  return config;
});

instanceCore.interceptors.response.use(
  (response) => response,
  (error: AxiosError<any>) => {
    // Network / fetch-like error (no response at all)
    if (!error.response) {
      // Equivalent of status === 'FETCH_ERROR'
      console.log('Stop playing with Network tab and turn the internet back on :)');
      return Promise.reject(error);
    }

    const status = error.response.status;

    // 401 — invalid / expired token
    if (status === 401) {
      localStorage.removeItem('token');
      delete instanceCore.defaults.headers.common['Authorization'];
      window.location.reload();
      window.location.replace(window.location.origin);
    }

    // Map statuses to notifications (same as isRejected block)
    // if (status === 400) {
    //   store?.dispatch(openClientErrorNotify_400());
    // }

    if (status === 405) {
      store?.dispatch(openCannotChangeCurrentResourceNotify_405());
    }

    if (status === 500) {
      store?.dispatch(openServerErrorNotify_500());
    }

    if (status === 502) {
      // console.log('технические работы');
      if (window.location.href.search('technical-service') === -1) {
        return (window.location.href = '/technical-service');
      }
    }
    return Promise.reject(error);
  }
);
